import { Box, Button, CircularProgress, Grid } from "@mui/material";
import { grey, red } from "@mui/material/colors";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { post } from "../../../utils/io";
import PasswordVerification from "../PasswordVerification";

function VerifyPassword() {
  const history = useHistory();
  const location = useLocation();
  const token = location.hash.substring(1);

  const [input, setInput] = useState({
    password: "",
    confirmPassword: "",
  });
  const [isPasswordError, setIsPasswordError] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [isRequesting, setIsRequesting] = useState(false);
  const [isInvalidToken, setIsInvalidToken] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const setPassword = (value) =>
    setInput((pre) => ({ ...pre, password: value }));

  const setConfirmPassword = (value) =>
    setInput((pre) => ({ ...pre, confirmPassword: value }));

  useEffect(() => {
    setIsLoading(true);
    async function tokenVerified() {
      const res = await post(`/users/password_reset/validate_token`, {
        confirmation_token: token,
      });
      if (res.status !== 204) {
        setIsInvalidToken(true);
      }
      setIsLoading(false);
    }
    tokenVerified();
  }, [token]);

  const isButtonDisabled = () =>
    isRequesting ||
    !input.confirmPassword ||
    !input.password ||
    input.password !== input.confirmPassword ||
    isPasswordError;

  const onSubmitForm = async () => {
    setIsRequesting(true);
    setErrMessage("");

    try {
      const payload = {
        new_password: input.password,
        confirmation_token: token,
      };
      const response = await post("/users/password_reset/complete", payload);
      setIsRequesting(false);
      if (response.status !== 204) {
        return setErrMessage(response.data[0] || "Failed to update password.");
      }
      history.push("/");
    } catch (error) {
      setErrMessage("Failed to update password.");
      setIsRequesting(false);
    }
    return null;
  };

  return (
    <Grid
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isLoading && <CircularProgress />}
      {!isLoading && isInvalidToken && (
        <Box
          sx={{
            background: "#d3d3d347",
            padding: "15px",
            borderRadius: 8,
          }}
        >
          <h2>Your confirmation link is invalid or expired</h2>
          <p>Try requesting a password reset again.</p>
        </Box>
      )}
      {!isLoading && !isInvalidToken && (
        <Box
          sx={{
            border: `1px solid ${grey[300]}`,
            padding: "15px",
            borderRadius: "4px",
            maxWidth: 400,
          }}
        >
          <h3>Select a password</h3>
          <PasswordVerification
            password={input.password}
            setPassword={setPassword}
            confirmPassword={input.confirmPassword}
            setConfirmPassword={setConfirmPassword}
            setError={setIsPasswordError}
          />
          {errMessage && (
            <Box
              sx={{
                color: red[500],
                fontStyle: "italic",
                textAlign: "center",
                marginTop: 0,
              }}
            >
              {errMessage}
            </Box>
          )}
          <Button
            onClick={onSubmitForm}
            variant="contained"
            color="primary"
            sx={{ width: "100%" }}
            disabled={isButtonDisabled()}
          >
            {isRequesting && (
              <CircularProgress size={16} sx={{ marginRight: "10px" }} />
            )}{" "}
            Submit
          </Button>
        </Box>
      )}
    </Grid>
  );
}

export default VerifyPassword;
